import React, { Component, PropTypes } from 'react';
import { reduxForm, Field, SubmissionError } from 'redux-form';
import classnames from 'classnames';
import isEmail from 'sane-email-validation';
import AnimatedButton from 'common/components/animated_button';
import {
  DEFAULT_REQUIRED_MESSAGE, EMAIL_INVALID_MESSAGE, TextInputField, EmailInputField,
} from 'common/components/form_fields';
import { subscribeRequest } from 'marketing/ducks';

let Form = ({
  submit_label, handleSubmit, callback, showSingleNameField=false, hideNameFields=false,
  notice, submitting, error, submitFailed, promo
}) => (
  <div>
    <form onSubmit={handleSubmit}>
      <Field name="email" component={EmailInputField} label="Email Address"/>

      { !hideNameFields &&
      <Field name="first_name" component={TextInputField} label="First Name" /> }

      { !showSingleNameField && !hideNameFields &&
      <Field name="last_name" component={TextInputField} label="Last Name" /> }

      <AnimatedButton processing={submitting} type="submit" label={submit_label}
        processingLabel="Submitting..." errorMsg={error || submitFailed}
        successMsg="Done!" onClick={callback} />
      <p className="notice"
        dangerouslySetInnerHTML={{ __html: notice || "100% privacy guaranteed" }}></p>
    </form>
    { !!promo && <h4 className="promo">{ promo }</h4> }
  </div>
);

const validate = (values) => {
  if (!values.email || !values.email.trim()) {
    return { email: DEFAULT_REQUIRED_MESSAGE };
  }

  if (!isEmail(values.email)) {
    return { email: EMAIL_INVALID_MESSAGE };
  }
}

Form = reduxForm({
  form: 'EmailSubscriptionForm',
  validate
})(Form);

export default class EmailSubscriptionForm extends Component {
  constructor(props) {
    super(props);

    this.state = { done: false };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(formData) {
    const { csTag, pageUrlStem } = this.props;
    const data = {
      ...formData,
      tags: csTag? [csTag] : undefined,
      landing_page_url_stem: pageUrlStem
    };

    return subscribeRequest(data)
      .then(() => this.setState({ done: true }))
      .catch(res => {
        throw new SubmissionError({ secret: 'Error submitting form. Please try again.' });
      });
  }

  render() {
    const { className, background, align, formTitle, successTitle } = this.props;
    const style = (!background || ["gray", "white"].includes(background))? undefined : { background };

    return (
      <div className={classnames('block block-email-subs-form', className, background)} style={style}>
        <div className={classnames("row", align)}>
          <div className="columns medium-16">
            { this.state.done?
            <div className="done text-center">
              { !!successTitle && <h3 className="form-title">{ successTitle }</h3> }
              <h3 className="text-success">
                <i className="fa fa-check-circle"/><br/>
                Thanks.<br/>Please check your email.
              </h3>
            </div> :
            <div>
              { !!formTitle && <h3 className="form-title">{ formTitle }</h3> }
              <Form {...this.props} onSubmit={this.handleSubmit} />
            </div> }
          </div>
        </div>
      </div>
    );
  }
}

EmailSubscriptionForm.propTypes = {
  submit_label: PropTypes.string,
  action_url: PropTypes.string,
  security_code: PropTypes.string,
  promo: PropTypes.string,
  className: PropTypes.string,
  align: PropTypes.string,
  background: PropTypes.string,
  notice: PropTypes.string,
  showSingleNameField: PropTypes.bool,
  hideNameFields: PropTypes.bool,
  pageUrlStem: PropTypes.string.isRequired,
  formTitle: PropTypes.string,
  successTitle: PropTypes.string,
  csTag: PropTypes.string,
};
